import { Link } from "react-router-dom";
import { Phone, MessageCircle, CalendarDays } from "lucide-react";
import { useTheme } from "@/components/ThemeContext";
import ScrollReveal from "@/components/ScrollReveal";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_luxury-ride-avellino/artifacts/b7diefut_ncc-avellino.png";

export default function HeroSection() {
  const { isDark } = useTheme();

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="Transfer Avellino - Servizio NCC Premium" className="w-full h-full object-cover" />
        <div className={`absolute inset-0 ${isDark ? "bg-gradient-to-r from-black/85 via-black/60 to-black/30" : "bg-gradient-to-r from-white/90 via-white/70 to-white/30"}`} />
        <div className={`absolute inset-0 ${isDark ? "bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" : "bg-gradient-to-t from-[#F5F0E8] via-transparent to-transparent"}`} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-32 pb-20">
        <ScrollReveal>
          <span className="text-xs font-medium tracking-[0.3em] uppercase text-[#C9A646] block mb-6">
            Noleggio con conducente premium
          </span>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <h1 className={`text-4xl sm:text-5xl lg:text-6xl tracking-tight font-normal max-w-3xl leading-[1.1] mb-6 ${isDark ? "text-white" : "text-[#1A1A1A]"}`}>
            Il tuo viaggio,
            <br />
            <span className="italic text-[#C9A646]">senza compromessi</span>
          </h1>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <p className={`text-base md:text-lg max-w-xl mb-10 leading-relaxed ${isDark ? "text-[#A1A1AA]" : "text-[#555]"}`}>
            Servizi NCC premium per aeroporti, stazioni, viaggi di affari, eventi e cerimonie.
            Ogni viaggio è un'esperienza su misura.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.3}>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="tel:+393784035054" data-testid="hero-call-btn" className="inline-flex items-center justify-center gap-2 bg-[#C9A646] text-[#0A0A0A] px-8 py-4 text-sm font-medium tracking-wider uppercase hover:bg-[#E1C16E] transition-all duration-300">
              <Phone className="w-4 h-4" strokeWidth={1.5} />
              Chiama Ora
            </a>
            <Link to="/prenota" data-testid="hero-book-btn" className="inline-flex items-center justify-center gap-2 bg-transparent border border-[#C9A646] text-[#C9A646] px-8 py-4 text-sm font-medium tracking-wider uppercase hover:bg-[#C9A646]/10 transition-all duration-300">
              <CalendarDays className="w-4 h-4" strokeWidth={1.5} />
              Prenota il tuo Transfer
            </Link>
            <a href="https://wa.me/393784035054?text=Salve%2C%20vorrei%20richiedere%20un%20preventivo." target="_blank" rel="noopener noreferrer" data-testid="hero-whatsapp-btn" className="inline-flex items-center justify-center gap-2 bg-white/5 border border-white/10 text-white px-8 py-4 text-sm font-medium tracking-wider uppercase hover:bg-white/10 backdrop-blur-md transition-all duration-300">
              <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
              Richiedi Preventivo
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
